<style lang="less" scoped>
  @import url('~bjxy-common/helper/util.less');

  .container {
    background-color: rgba(0, 0, 0, .6);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 11;
    .content-box {
      .center();
        margin-top: -3rem;
      .login-dialog-box{
        position: relative;
        background-color: white;
        width: 17.25rem;
        border-radius: .4rem;
        padding: 1.5rem .8rem 1rem;
        .btn-close{
          position: absolute;
          top: .3rem;
          right: .3rem;
          width: 1rem;
          height: 1rem;
          background: url('./img/ico_close.png') no-repeat 50%;
          background-size: .5rem;
        }
        .input-box {
          position: relative;
          width: 100%;
          margin-top: .5rem;
          .input {
            width: 100%;
            height: 2.5rem;
            line-height: 1.5rem;
            padding: .5rem 1.1rem;
            font-size: .8rem;
            background: #fff;
            border-radius: 1.25rem;
            border: 1px solid #d7d7d7;
          }

        }
        .sms-code-box {
          .send-sms-code {
            position: absolute;
            z-index: 1;
            right: 0;
            top: 0;
            width: 6.25rem;
            height: 2.5rem;
            line-height: 2.5rem;
            font-size: .7rem;
            color: #ffa448;
            text-align: center;
            display: block;
            &:before {
              position: absolute;
              z-index: 1;
              left: 0;
              top: .9rem;
              width: 1px;
              height: .7rem;
              background: #c8c8c8;
              content: "";
              display: block;
            }
          }
        }
        .submit{
          height: 2.3rem;
          line-height: 2.3rem;
          text-align: center;
          font-size: .9rem;
          text-decoration: none;
          margin-top: 1rem;
          background: #ffa448;
          border-radius: 1.25rem;
          color: #fff;
        }
        .wrapper{
          display: flex;
          justify-content: space-between
        }
        .toggleType{
          color: #a7a7a7;
          margin-top: 0.5rem;
          margin-left: 0.5rem;
        }
        .findPassword{
          color: #a7a7a7;
          margin-top: 0.5rem;
          margin-right: 0.5rem;
        }
      }
    }
  }

</style>
<template>

  <transition name="fade" mode="out-in" appear>
    <div v-show="showFlag" class="container">
      <div class="content-box">
        <div class="login-dialog-box">
          <div class="btn-close" @click="close"></div>
          <div class="input-box">
            <input :style="styleObject.input" v-report="{cmdid:65048, buttonid:0,mobile}" v-xreport="{eventName:'zhanghaoshurukuang', actionType: 'element'}" v-model="mobile" type="tel" class="input phone-num" maxlength="11" placeholder="请输入手机号">
          </div>
          <!--短验登录-->
          <div class="input-box sms-code-box" v-if="loginType=='SMS'">
            <input :style="styleObject.input" v-report="{cmdid:65048, buttonid:4}" v-xreport="{eventName:'dengluduanxinyanzhengmashurukuang', actionType: 'element'}" class="input sms-code" type="tel" maxlength="4" autocomplete="off" v-model="smsCode" name="smscode" placeholder="请输入验证码">
            <a v-if="count>0" class="send-sms-code">{{count}}s</a>
            <a :style="styleObject.sendSmsCode" v-report="{cmdid:65048, buttonid:5}" v-xreport="{eventName:'dengluhuoquyanzhengma', actionType: 'element'}" v-else class="send-sms-code" @click="sendSmsCode">获取验证码</a>
          </div>
          <!--密码登录-->
          <div class="input-box" v-else>
            <input :style="styleObject.input" v-report="{cmdid:65048,buttonid:1}" v-xreport="{eventName:'mimashurukuang', actionType: 'element'}" v-model="password" type="password" class="input password" maxlength="16" placeholder="请输入密码">
          </div>
          <p class="submit" :style="styleObject.submit" @click="login" v-report="{cmdid:65048, buttonid:2}" v-xreport="{eventName:'lijidenglu', actionType: 'element'}">登录</p>
          <div class="wrapper">
            <p class="toggleType" @click="toggleType">{{loginType==='SMS'?'账号密码登录':'短信验证码登录'}}</p>
            <p class="findPassword" v-if="isfindPassword" @click="findPassword">忘记密码</p>
          </div>
        </div>
      </div>
    </div>
  </transition>

</template>

<script>
  import {mixin, api, dict} from '../utils'
  import addUrlQuery from 'bjxy-common/helper/addUrlQuery'
  import getQueryString from 'bjxy-common/helper/getQueryString'
  import md5Fun from 'bjxy-common/helper/md5Fun'
  import rmNull from 'bjxy-common/helper/rmNull'
  import getSmsTpl from '../utils/getSmsTplId'
  import replaceDomain from 'bjxy-common/xyHelper/replaceDomain'
  import getGeetest from '../utils/getGeetest'
  import getQueryJson from 'bjxy-common/helper/getQueryJson'
  import throttle from '../utils/throttle'
  import cookieKeyword from '../utils/cookieKeyword'
  import getBrowserInfo from 'bjxy-common/helper/getBrowserInfo';
  import { bindWechat } from '@/component/utils/bindWechat'
  const ua = getBrowserInfo();

  export default {
    data () {
      return {
        showFlag:false,
        mobile:'',
        password:'',
        source:  getQueryString('source'),
        count: 0,
        loginType: 'SMS',
        smsCode:'',
        smsId:'',
      }
    },
    watch: {
      showFlag (val) {
        document.body.style.position = val ? 'fixed' : ''
      },
    },
    props:{
      userInfo:{
        type:Object,
        default:function () {
          return{
            mobile:'',
            password:''
          }
        }
      },
      config: {
        type:Object,
        default: function () {
          return {
            extend:{}
          }
        }
      }
    },
    computed: {
      params(){
        var params = {
          landId: this.config.landId,
          source: this.source,
          partner_data: getQueryString('partner_data'),
          fromUrl: encodeURIComponent(location.href)
        }
        return rmNull(params)
      },
      extend(){
        return this.config.extend;
      },
      hasRegRedirect(){
        if(ua.ios){
          return this.extend.iosHasRegUrl || this.config.hasRegRedirect;
        }else if(ua.android){
          return this.extend.androidHasRegUrl || this.config.hasRegRedirect;
        }else{
          return this.config.hasRegRedirect;
        }
      },
      styleObject(){
        return {
          input:rmNull({
            borderRadius: this.extend.border_radius,
            border: this.extend.is_border
          }),
          submit:rmNull({
            borderRadius: this.extend.border_radius,
            border: this.extend.is_border,
            color: this.extend.but_color,
            backgroundColor: this.extend.but_bg
          }),
          sendSmsCode: rmNull({
            color: this.extend.code_color
          }),
        }
      },
      productType(){
        return this.extend.productType
      },
      isfindPassword(){
        if(this.productType==15||this.productType==17||this.productType==22||this.productType==26){
          return false
        }else{
          return true
        }
      },
      smsTpl(){
        return getSmsTpl(this.productType,this.extend.partnerName)
      },
    },
    mixins:[mixin],
    activated(){
      this.post('/h5/homepage/get_render_page_config',getQueryJson()).then(json=>{
        if(json.data.loginState === 1){
          setTimeout(() => {
            location.href = addUrlQuery(replaceDomain(this.hasRegRedirect), this.params)
          }, 50)
        }
      })
    },
    methods: {
      findPassword(){
        location.href =dict.findPassword(this.productType)
      },
      toggleType(){
        this.loginType = (this.loginType == 'SMS')? 'PASSWORD':'SMS';
      },
      show(){
        this.report({cmdid:65048, buttonid:-1})
        this.mobile = this.userInfo.mobile;
        this.password = this.userInfo.password
        this.showFlag = true;
        if(this.test({account:this.mobile},true)){
          this.sendSmsCode()
        }
      },
      close(){
        this.showFlag = false;
        this.$emit('userInfo',{
          mobile: this.mobile,
          password: this.password
        })
      },
      countWork (count) {
        this.count = count;
        var timer = setInterval(() => {
          if (this.count > 0) {
            this.count--
          } else {
            clearInterval(timer)
          }
        }, 1000)
      },
      // 发送短信验证码
      sendThrottle: throttle(function(){
        getGeetest().then(this.send.bind(this),this.toast.bind(this))
      }, 2000),
      sendSmsCode () {
        if(!this.test({account:this.mobile}))return;
        // 极验
        this.sendThrottle()
      },
      send(result){
        var params = {
          skeyType: dict.skeyType,
          account: this.mobile,
          accountType: 1, //int 必填 1手机号 2邮箱
          userVerify: JSON.stringify({
              challenge: result.geetest_challenge,
              validate: result.geetest_validate,
              seccode: result.geetest_seccode,
              id: result.id,
            }),
          smsTplId: this.smsTpl.smsTplId,
          smsTplVersion: this.smsTpl.smsTplVersion,
        };
        if (!this.test(params)) return
        this.post(api.SEND_VERIFY_CODE, params).then(json => {
          if (json.status) {
            this.countWork(60)
            this.smsId = json.data.id;
            this.toast('发送短信成功')
          } else {
            this.toast(json.msg);
          }
        })
      },
      login(){
        const dataJson = getQueryJson();
        var params = {
          loginType: this.loginType,
          skeyType: dict.skeyType,
          account: this.mobile,
          accountType: 1,
          flowExtendInfo: JSON.stringify(rmNull({
            sourceType: this.extend.sourceType||'landing-h5',
            channelId: this.source,
            mobile: this.mobile,
            activityId: this.extend.activityId,
            osType: 'h5',
            dataJson: JSON.stringify(dataJson),
            ...cookieKeyword
          }))
        };
        if(this.loginType=='SMS'){
          let userVerify = {
            code: this.smsCode,
            id: this.smsId,
          }
          if(!this.test(userVerify))return
          if(!this.test(params))return
          params.userVerify =  JSON.stringify(userVerify)
          this.postLogin(params)
        }else {
          params.password = this.password
          if(!this.test(params))return
          params.password = md5Fun(params.password)
          // 极验
          getGeetest().then((result)=>{
            Object.assign(params,{
              userVerify: JSON.stringify({
                challenge: result.geetest_challenge,
                validate: result.geetest_validate,
                seccode: result.geetest_seccode,
                id: result.id,
              })
            })
            this.postLogin(params)
          },this.toast)
        }
      },
      postLogin(params) {
        this.post(api.PAY_LOGIN,params).then(json=>{
          if (json.status) {
            this.report({cmdid:65048,buttonid:3,mobile:this.mobile})
            this.xreport('dengluchenggong')
            bindWechat(this.config.openId, ()=>{
              setTimeout(() => {
                location.href = addUrlQuery(replaceDomain(this.hasRegRedirect), this.params)
              }, 50)
            })
          } else {
            return this.toast(json.msg);
          }
        },json=>{
          this.toast(json.errstr)
        })
      }
    }
  }
</script>
